var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 22 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D05C494E-F414-466E-878E-D61D5C654783") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-3-Copy-17",
    transform: "translate(-1069.000000, -4370.000000)",
    fill: "#17171B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter-(4)-copy",
    transform: "translate(1069.941340, 4370.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0586596,1.924953 C19.3064599,2.24994507 18.5291868,2.47493958 17.7017671,2.57493714 C18.5542601,2.07494934 19.2061666,1.27496887 19.5070465,0.299992676 C18.7047001,0.77498108 17.8271337,1.09997315 16.8994207,1.29996826 C16.147221,0.499987793 15.069068,0 13.8906218,0 C11.6089492,0 9.77859655,1.84995484 9.77859655,4.0998999 C9.77859655,4.42489197 9.80366988,4.72488465 9.87888985,5.02487732 C6.46891772,4.87488098 3.46011878,3.22492127 1.4291795,0.74998169 C-0.0250733245,3.34991821 1.60469277,5.49986573 2.68284572,6.22484803 C2.03093928,6.22484803 1.37903285,6.02485291 0.827419708,5.72486023 C0.827419708,7.7498108 2.2565992,9.4247699 4.11202522,9.79976075 C3.71085203,9.9247577 2.80821234,9.99975587 2.2565992,9.87475892 C2.78313902,11.4997192 4.31261181,12.6996899 6.09281785,12.7246893 C4.68871168,13.8246625 2.63269907,14.6996411 0,14.4246478 C1.83035269,15.5996191 3.9866586,16.2746027 6.31847777,16.2746027 C13.8906218,16.2746027 18.002647,10.0247553 18.002647,4.62488709 C18.002647,4.44989136 18.002647,4.27489563 17.9775737,4.0998999 C18.8300667,3.47491516 19.5321198,2.74993286 20.0586596,1.924953 L20.0586596,1.924953 Z",
    id: "_x30_4.Twitter"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e322c6487d0ffd236068255bad435c08.svg";
export { ForwardRef as ReactComponent };